import { ReactNode } from 'react';
import { Navigate } from '@tanstack/react-router';
import authStore from 'shared/auth/authStore';

export const AdminGuard = ({ children }: { children: ReactNode }) => {
  if (!authStore.hasRole('ROLE_ADMIN')) {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};
